export default __webpack_public_path__ + "static/media/NavMapIcons-07.2dc13f1d.png";